import { Metamodel, DataFlowDSLAdapterRegistry, Owned } from 'shell-models-lib';
import { DataFlowExpressionUtils } from '../expression.util';
import { DataFlowSource } from 'app/model/dataflow/dataflow-source';
import { HiveSettings } from 'app/model/dataflow/dataset-settings/hive-dataset-settings';
import { SynapseAnalyticsFormatAdapter } from './synapse-analytics.adapter';
import { DataFlowSink } from 'app/model/dataflow/dataflow-sink';

@DataFlowDSLAdapterRegistry.adapter({
    model: Metamodel.modelFor(HiveSettings)
})
export class HiveFormatAdapter extends SynapseAnalyticsFormatAdapter {
    protected async toSourceDSL(hiveSettings: HiveSettings): Promise<string[]> {
        const props = await super.toSourceDSL(hiveSettings);
        props.push(
            `storageContainer: ${DataFlowExpressionUtils.wrapExpressionConfigValue(hiveSettings.storageContainer)}`
        );
        // TODO: revert when this is fixed
        props.push(`storageFolderPath: ''`);
        props.push(
            `stagingDatabaseName: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                hiveSettings.stagingDatabaseName
            )}`
        );
        return props;
    }

    protected async toSinkDSL(hiveSettings: HiveSettings): Promise<string[]> {
        const props = await super.toSinkDSL(hiveSettings);
        props.push(
            `storageContainer: ${DataFlowExpressionUtils.wrapExpressionConfigValue(hiveSettings.storageContainer)}`
        );
        props.push(
            `storageFolderPath: ${DataFlowExpressionUtils.wrapExpressionConfigValue(hiveSettings.storageFolderPath)}`
        );
        props.push(
            `stagingDatabaseName: ${DataFlowExpressionUtils.wrapExpressionConfigValue(
                hiveSettings.stagingDatabaseName
            )}`
        );
        // nimoolen: leaving this here because we may want it back in the future
        // if (hiveSettings.clusteredByBuckets) {
        //     props.push(`clusteredByBuckets: ${DataFlowExpressionUtils.wrapExpressionConfigValue(hiveSettings.clusteredByBuckets, IntegerDataFlowType.TYPE)}`)
        // }
        // if (hiveSettings.transform instanceof DataFlowSink) {
        //     const clusteredBy = hiveSettings.clusteredBy.filter((column) => column.expression);
        //     const columns = clusteredBy.map((col) => DataFlowExpressionUtils.wrapExpressionConfigValue(col, StringDataFlowType.TYPE, true)).join(',');
        //     if (!!columns) {
        //         props.push(`clusteredBy:[${columns}]`);
        //     }
        // }
        return props;
    }

    protected async toSourceModel(
        owner: DataFlowSource,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<HiveSettings> {
        const hiveSettings = Owned.create<HiveSettings>(HiveSettings.MODEL, owner);
        hiveSettings.initialize(undefined);
        await super.toSourceModel(owner, configs, handledConfigs, hiveSettings);
        if (configs.has('storageContainer')) {
            hiveSettings.storageContainer = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('storageContainer'),
                owner
            );
            handledConfigs.push('storageContainer');
        }
        if (configs.has('storageFolderPath')) {
            hiveSettings.storageFolderPath = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('storageFolderPath'),
                owner
            );
            handledConfigs.push('storageFolderPath');
        }
        if (configs.has('schemaName')) {
            hiveSettings.schemaName = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('schemaName'),
                owner
            );
            handledConfigs.push('schemaName');
        }
        if (configs.has('tableName')) {
            hiveSettings.tableName = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('tableName'),
                owner
            );
            handledConfigs.push('tableName');
        }
        if (configs.has('stagingDatabaseName')) {
            hiveSettings.stagingDatabaseName = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('stagingDatabaseName'),
                owner
            );
            handledConfigs.push('stagingDatabaseName');
        }
        return hiveSettings;
    }

    protected async toSinkModel(
        owner: DataFlowSink,
        configs: Map<string, string>,
        handledConfigs: string[]
    ): Promise<HiveSettings> {
        const hiveSettings = Owned.create<HiveSettings>(HiveSettings.MODEL, owner);
        hiveSettings.initialize(undefined);
        await super.toSinkModel(owner, configs, handledConfigs, hiveSettings);
        if (configs.has('storageContainer')) {
            hiveSettings.storageContainer = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('storageContainer'),
                owner
            );
            handledConfigs.push('storageContainer');
        }
        if (configs.has('stagingDatabaseName')) {
            hiveSettings.stagingDatabaseName = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('stagingDatabaseName'),
                owner
            );
            handledConfigs.push('stagingDatabaseName');
        }
        if (configs.has('storageFolderPath')) {
            hiveSettings.storageFolderPath = DataFlowExpressionUtils.unwrapExpressionConfigValue(
                configs.get('storageFolderPath'),
                owner
            );
            handledConfigs.push('storageFolderPath');
        }
        // nimoolen: leaving this here because we may want it back in the future
        // if (configs.has('clusteredBy')) {
        //     hiveSettings.clusteredBy = DataFlowExpressionUtils.parseExpressionArrayInDsl(configs.get('clusteredBy'), owner, StringDataFlowType.TYPE, true);
        //     handledConfigs.push('clusteredBy');
        // }
        // if (configs.has('clusteredByBuckets')) {
        //     hiveSettings.clusteredByBuckets = DataFlowExpressionUtils.unwrapExpressionConfigValue(configs.get('clusteredByBuckets'), owner, IntegerDataFlowType.TYPE);
        //     handledConfigs.push('clusteredByBuckets');
        // }
        return hiveSettings;
    }
}
